import { styled } from '@mui/material/styles';
import { mergeClasses } from 'minimal-shared/utils';
import { forwardRef } from 'react';
import SimpleBar from 'simplebar-react';

import { scrollbarClasses } from './classes';
import type { ScrollbarProps } from './types';

// ----------------------------------------------------------------------

export const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(
  (props, ref) => {
    const {
      slotProps,
      children,
      fillContent = true,
      className,
      sx,
      ...other
    } = props;

    return (
      <ScrollbarRoot
        scrollableNodeProps={{ ref }}
        clickOnTrack={false}
        fillContent={fillContent}
        className={mergeClasses([scrollbarClasses.root, className])}
        sx={[
          {
            '& .simplebar-wrapper': slotProps?.wrapperSx as React.CSSProperties,
            '& .simplebar-content-wrapper':
              slotProps?.contentWrapperSx as React.CSSProperties,
            '& .simplebar-content': slotProps?.contentSx as React.CSSProperties,
          },
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...other}
      >
        {children}
      </ScrollbarRoot>
    );
  }
);
Scrollbar.displayName = 'Scrollbar';

// ----------------------------------------------------------------------

const ScrollbarRoot = styled(SimpleBar, {
  shouldForwardProp: (prop: string) => !['fillContent', 'sx'].includes(prop),
})<Pick<ScrollbarProps, 'fillContent'>>(({ fillContent }) => ({
  minWidth: 0,
  minHeight: 0,
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  ...(fillContent && {
    '& .simplebar-content': {
      display: 'flex',
      flex: '1 1 auto',
      minHeight: '100%',
      flexDirection: 'column',
    },
  }),
}));
